import { BrowserRouter, Routes, Route } from "react-router-dom";
import BrandPage from "./pages/BrandPage";
import HomePage from "./pages/HomePage";
import LibraryPage from "./pages/LibraryPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/brand" element={<BrandPage />} />
        <Route path="/library" element={<LibraryPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
